module.exports = __webpack_public_path__ + "static/media/temperance.371507d9.jpeg";